import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';
import { toImageWithPreservedAspectRatioSize } from 'lib/image';

const StoreAd = ({
  className,
  description,
  gaEventCategory,
  image,
  storeName,
  url,
}) => {
  const onClickHandler = () => {
    sendEvent({
      action: `banner_full_${storeName}__click`,
      category: gaEventCategory,
    });
  };

  return (
    <a
      className={twJoin(
        'w-full rounded-4 border border-neutral-high-200 dark:border-neutral-low-400',
        className
      )}
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onClickHandler}
    >
      <Image
        alt={description}
        className="h-auto w-full min-w-full rounded-4 lg:max-h-[320px]"
        height={320}
        loading={null}
        sizes="(max-width: 768px) 328px, 492px (min-width: 768px) 492px, 656px, 944px"
        src={toImageWithPreservedAspectRatioSize(image, 328)}
        srcSet={`
          ${toImageWithPreservedAspectRatioSize(image, 492)} 492w,
          ${toImageWithPreservedAspectRatioSize(image, 656)} 656w,
          ${image} 944w,
        `}
        width={328}
        priority
      />
    </a>
  );
};

StoreAd.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  description: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default StoreAd;
